/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_Col_RefInputs */

const vi_customer_debt_ledger_col_ref = /** @type {(inputs: Customer_Debt_Ledger_Col_RefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chứng từ`)
};

/**

* @param {Customer_Debt_Ledger_Col_RefInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_col_ref = /** @type {((inputs?: Customer_Debt_Ledger_Col_RefInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_Col_RefInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_col_ref(inputs)
});